/* Nordestic R38: Nach dem Seitenaufbau die restlichen Bilder im Hintergrund laden,
   damit beim Scrollen nichts mehr nachlädt. Die ersten Bilder (Titelbild, Galerie) lädt die Seite selbst zuerst.
   Nicht im Datensparmodus und nicht bei 2G/3G. Fußzeile (Länderflaggen) bleibt außen vor. */
(() => {
  if (window.__nordesticWarm) return;
  window.__nordesticWarm = true;
  const c = navigator.connection || {};
  if (c.saveData || /(^|-)[23]g$/.test(c.effectiveType || '')) return;
  const MAX = 36, BATCH = 3;
  let done = 0, running = false, timer = 0;
  const scope = () => document.getElementById('main') || document.body;
  const pending = () => [...scope().querySelectorAll('img[loading="lazy"]')].filter(img =>
    !img.complete && !img.dataset.nordesticWarm &&
    (img.getAttribute('src') || img.getAttribute('srcset')) &&
    !img.closest('[data-nowarm],dialog:not([open]),template,footer,.shopify-section-group-footer-group,.shopify-section-group-header-group,.popover'));
  const run = async () => {
    if (running) return;
    running = true;
    try {
      for (;;) {
        const list = pending().slice(0, BATCH);
        if (!list.length || done >= MAX) break;
        await Promise.all(list.map(img => new Promise(resolve => {
          img.dataset.nordesticWarm = '1';
          done += 1;
          const fin = () => resolve();
          img.addEventListener('load', fin, {once: true});
          img.addEventListener('error', fin, {once: true});
          setTimeout(fin, 6000);
          img.loading = 'eager';
        })));
      }
    } finally { running = false; }
  };
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 200));
  const kick = () => { clearTimeout(timer); timer = setTimeout(() => idle(run, {timeout: 2000}), 300); };
  const start = () => {
    kick();
    try { new MutationObserver(kick).observe(scope(), {childList: true, subtree: true}); } catch {}
  };
  if (document.readyState === 'complete') setTimeout(start, 2500);
  else addEventListener('load', () => setTimeout(start, 2500), {once: true});
})();

/* R43 – Sprung von der Startseite in den 3D-Raumplaner: <Produkt-URL>#raumplaner öffnet den Planer, sobald die Seite steht. */
(function () {
  if (location.hash !== '#raumplaner' || window.__nordesticPlan) return; window.__nordesticPlan = true;
  var RE = /In deinem Raum ansehen|Raum planen|Am Sofa vergleichen|Meinen Raumplan erstellen/, n = 0;
  var t = setInterval(function () {
    var root = document.getElementById('nordestic-product-root');
    var btn = root && Array.prototype.filter.call(document.querySelectorAll('#nordestic-product-root button, .nordestic-slot button'), function (b) { return RE.test(b.textContent || '') && !b.disabled; })[0];
    if (btn) { clearInterval(t); try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} btn.click(); }
    else if (++n > 60) clearInterval(t);
  }, 250);
})();

/* R51 · NordicDesk: „Wand & Montage” öffnet ein Fenster mit Wandtypen und Höhentabelle, statt ans Seitenende zu springen.
   Gibt false zurück, wenn der Abschnitt (noch) nicht auf der Seite steht – dann springt die Seite wie bisher. */
window.nordesticWallDialog = function () {
  var src = document.querySelector('.nordestic-slot .desk-wall-guide') || document.querySelector('#nordestic-product-root .desk-wall-guide');
  if (!src || typeof HTMLDialogElement === 'undefined') return false;
  var d = document.querySelector('dialog.nordestic-wall-dialog');
  if (!d) {
    d = document.createElement('dialog'); d.className = 'nordestic-wall-dialog'; d.setAttribute('aria-label', 'Mur et montage');
    d.innerHTML = '<div class="nordestic-wall-head"><strong>Mur et montage</strong><button type="button" data-close aria-label="Fermer">\u00D7</button></div><div class="nordestic-wall-body nordestic-slot"><div class="desk-page"></div></div><div class="nordestic-wall-foot"><button type="button" data-goto>Voir toute la section sur la page</button></div>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-close]')) d.close();
      else if (e.target.closest('.desk-heights button')) {
        // Höhenwert im Fenster: schließen und denselben Wert im Abschnitt auslösen (öffnet den Raumplaner mit dieser Höhe)
        var all = Array.prototype.slice.call(d.querySelectorAll('.desk-heights button')), i = all.indexOf(e.target.closest('button'));
        var orig = document.querySelectorAll('.nordestic-slot:not(.nordestic-wall-body) .desk-heights button, #nordestic-product-root .desk-heights button')[i];
        d.close(); if (orig) orig.click();
      }
      else if (e.target.closest('[data-goto]')) { d.close(); var t = document.getElementById('desk-wall') || document.querySelector('.desk-wall-guide'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }
  var box = d.querySelector('.desk-page'), copy = src.cloneNode(true);
  copy.removeAttribute('id'); Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
  box.innerHTML = ''; box.appendChild(copy);
  try { d.showModal(); } catch (e) { return false; }
  d.querySelector('.nordestic-wall-body').scrollTop = 0;
  return true;
};

/* R68: NordicDesk – Wandtypen und Höhentabelle stehen nur noch im Fenster „Wand & Montage”; Link dazu unter dem Raumplaner-Knopf */
(function () {
  if (typeof HTMLDialogElement === 'undefined' || !document.querySelector('script[src*="nordestic-desk"],link[href*="nordestic-desk"]')) return;
  document.documentElement.classList.add('has-wall-dialog');
  var queued = false;
  function add() {
    queued = false;
    var m = document.querySelector('.desk-mount .pdp-primary');
    if (!m || m.parentNode.querySelector('.nordestic-wall-more')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'nordestic-wall-more'; b.textContent = 'Voir les types de murs et le tableau des hauteurs';
    b.addEventListener('click', function () { window.nordesticWallDialog(); });
    m.insertAdjacentElement('afterend', b);
  }
  new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(add); } }).observe(document.documentElement, { childList: true, subtree: true });
  add();
})();

/* R156: Desktop – Bildwechsel in der Produktgalerie weich ueberblenden (Couchtisch, Lampen, Schreibtisch).
   Das alte Bild bleibt als Hintergrund stehen, bis das neue geladen ist und eingeblendet wurde. */
(() => {
  if (window.__nXf) return; window.__nXf = 1;
  const SEL = '.viewer .photo-view, .pdp-gallery-main';
  const wide = () => window.innerWidth > 760;
  const calm = () => { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };
  const box = n => n && n.parentElement && n.parentElement.matches && n.parentElement.matches(SEL) ? n.parentElement : null;
  const remember = img => { const b = box(img); if (!b || !img.naturalWidth) return; const cs = getComputedStyle(img); b.__nLast = {src: img.currentSrc || img.src, fit: cs.objectFit === 'contain' ? 'contain' : 'cover', pos: cs.objectPosition || 'center'}; };
  document.addEventListener('load', e => { const t = e.target; if (t && t.tagName === 'IMG') remember(t); }, true);
  const clear = b => { b.style.backgroundImage = ''; b.style.backgroundSize = ''; b.style.backgroundPosition = ''; b.style.backgroundRepeat = ''; b.removeAttribute('data-n-xf'); };
  const swap = (b, img) => {
    const last = b.__nLast; const tok = (b.__nTok = (b.__nTok || 0) + 1);
    if (!last || !last.src || !wide() || calm()) return;
    b.style.backgroundImage = 'url("' + last.src.replace(/"/g, '%22') + '")'; b.style.backgroundSize = last.fit; b.style.backgroundPosition = last.pos; b.style.backgroundRepeat = 'no-repeat';
    b.setAttribute('data-n-xf', '');
    img.style.opacity = '0';
    const done = () => { if (b.__nTok === tok) clear(b); img.style.opacity = ''; };
    const show = () => {
      if (!img.isConnected) return;
      remember(img);
      if (!img.animate) return done();
      const a = img.animate([{opacity: 0}, {opacity: 1}], {duration: 280, easing: 'ease-out'});
      img.style.opacity = '';
      a.onfinish = a.oncancel = done;
    };
    if (img.complete && img.naturalWidth) show();
    else { img.addEventListener('load', show, {once: true}); img.addEventListener('error', done, {once: true}); setTimeout(() => { if (img.style.opacity === '0') done(); }, 6000); }
  };
  const start = () => new MutationObserver(list => {
    for (const m of list) {
      const b = m.target; if (!b.matches || !b.matches(SEL)) continue;
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') swap(b, n); else if (n.tagName === 'VIDEO') { b.__nTok = (b.__nTok || 0) + 1; clear(b); }
      }
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
  start();
  document.querySelectorAll('.viewer .photo-view > img, .pdp-gallery-main > img').forEach(remember);
})();
